import I18n from '../../../config/i18n';
import { isFilterActive } from '../../../features/request/helpers';
import { FilterSet } from '../../../features/request/types';

import './FilterReset.css';

interface FilterResetProps {
  filterSet: FilterSet;
  resetFilterSet: () => void;
}

export default function FilterReset({
  filterSet,
  resetFilterSet,
}: FilterResetProps): JSX.Element | null {
  if (!isFilterActive(filterSet)) {
    return null;
  }

  return (
    <div className="filter-reset">
      <button className="filter-reset__button" type="button" onClick={resetFilterSet}>
        {I18n.t('search.reset_filters')}
      </button>
    </div>
  );
}
